import React, { Component } from "react";
import Axios from "axios";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";

import { useStyles } from "../../../Components/CSS/UserDetailStyle.css";
import UserHeader from "../../../Components/NavBar/User/UserHeader/UserHeader";
import { url } from "../../../Config/Config";
import CustomEmptyMessage from "../../../Components/CustomEmptyMessage/CustomEmptyMessage";
import CustomSiteLoader from "../../../Components/CustomSiteLoader/CustomSiteLoader";
import ResultFilterForm from "./ResultFilterForm/ResultFilterForm";
import SchoolHeader from "../SchoolHeader/SchoolHeader";
import ResultTable from "./ResultTable/ResultTable";
import { getUserRefreshToken } from "../../../Redux/Actions/actions";
import PageTitle from "../../../Components/PageTitle/PageTitle";

class UserResults extends Component {
  constructor(props) {
    super(props);
    this.state = {
      studentMarks: [],
      studentInfo: {},
      searchBy: {
        year: moment(new Date()).format("YYYY"),
        examination: "",
      },
    };
  }

  handleSearch = (e) => {
    this.setState({
      searchBy: { ...this.state.searchBy, [e.target.name]: e.target.value },
    });
  };

  componentDidMount() {
    this.getUserResults();
  }

  getUserResults = async () => {
    try {
      const responseStudent = await Axios.get(
        `${url}/api/students/${this.props.userId}`,
        {
          headers: { Authorization: `Bearer ${this.props.userToken}` },
        }
      );
      this.setState({ studentInfo: responseStudent.data.student });
      const response = await Axios.get(`${url}/api/marks/student`, {
        headers: {
          Authorization: `Bearer ${this.props.userToken}`,
        },
      });
      if (response.data.marks.length !== 0) {
        this.setState({
          studentMarks: response.data.marks,
          isEmpty: false,
        });
      } else {
        this.setState({
          studentMarks: [],
          isEmpty: true,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.userRefreshToken };
        this.props.getUserRefreshToken(refreshToken, this.props.role);
        this.getUserResults();
      }
    }
  };

  render() {
    const { classes } = this.props;
    let examTypeFilter = this.state.studentMarks
      .filter((data) => data.session === this.state.searchBy.year)
      .map((data) => data.examType);
    let marksFilter = this.state.studentMarks.filter(
      (data) =>
        data.session === this.state.searchBy.year &&
        data.examType === this.state.searchBy.examination
    );
    let studentDetails = marksFilter.length !== 0 && {
      firstName: this.state.studentInfo.firstName,
      lastName: this.state.studentInfo.lastName,
      studentClass: marksFilter[0].studentClass,
      section: marksFilter[0].section,
      faculty: marksFilter[0].faculty ? marksFilter[0].faculty : "",
      group: marksFilter[0].group ? marksFilter[0].group : "",
    };
    return (
      <div className={classes.root}>
        <UserHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />
          <div className={classes.sectionDesktop}>
            <PageTitle title="Results" refreshUrl={this.props.match.url} />
          </div>
          {this.state.studentMarks.length !== 0 ? (
            <div>
              <ResultFilterForm
                data={this.state.searchBy}
                examType={examTypeFilter}
                handleChange={this.handleSearch}
              />
              <div style={{ fontSize: 20, fontWeight: "bold" }}>Results</div>
              <br />
              <div>
                {marksFilter.length !== 0 ? (
                  <div>
                    <SchoolHeader
                      studentDetails={studentDetails}
                      examType={marksFilter[0].examType}
                    />
                    <ResultTable marks={marksFilter[0].marks} />
                  </div>
                ) : (
                  <div>Select Exam type to get the results</div>
                )}
              </div>
            </div>
          ) : this.state.isEmpty ? (
            <CustomEmptyMessage />
          ) : (
            <CustomSiteLoader />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userId: state.UserReducer.userId,
    userToken: state.UserReducer.userToken,
    userRefreshToken: state.UserReducer.userRefreshToken,
    role: state.UserReducer.role,
    isUser: state.UserReducer.isUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserRefreshToken: (refreshToken, role) => {
      dispatch(getUserRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(UserResults));
